export ProjectsList = '''
	name
	id
	projectID
	slug
	city
	country
	photo {
		mini
	}
'''
